import { injectable } from "inversify";
import { VintomError } from "src/api/model/error/VintomError";
import { Config } from "../../config/config";

export interface ErrorReporter {
  initialize(videoCode: string): void;
  sendErrorLog(error: VintomError): void;
}

@injectable()
export class ErrorReporterImpl implements ErrorReporter {
  private videoCode: string;

  initialize(videoCode: string): void {
    this.videoCode = videoCode;
  }

  sendErrorLog(error: VintomError): void {
    const videoLogUrl = Config.videoLogUrl(this.videoCode);
    fetch(videoLogUrl, {
      method: "POST",
      body: JSON.stringify(this.errorToPayload(error)),
    }).catch(() => {});
  }

  private errorToPayload(error: VintomError): any {
    return (
      "errorCode: " +
      error.errorCode +
      ", " +
      "message: " +
      error.message +
      ", " +
      "userAgent: " +
      error.errorAdditionalInfo.userAgent +
      ", " +
      "playerVersion: " +
      error.errorAdditionalInfo.playerVersion +
      ", " +
      "operatingSystem: " +
      error.errorAdditionalInfo.operatingSystem +
      ", " +
      "browserName: " +
      error.errorAdditionalInfo.browserName +
      ", " +
      "browserMajorVersion: " +
      error.errorAdditionalInfo.browserMajorVersion +
      ", " +
      "stackTrace: " +
      error.stackTrace
    );
  }
}
